<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/avignonesi')">Avignonesi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri')">Azienda
                        Agricola Casanova di Neri
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-salvioni')">Azienda Salvioni
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/castiglione-del-bosco')">Castiglione del Bosco
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/conti-constani')">Conti Constani
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-le-pupille')">Fattoria Le Pupille
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-poggio-di-sotto')">Fattoria Poggio di
                        Sotto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fontodi')">Fontodi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/frescobaldi')">Frescobaldi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/gianfranco-soldera')">Gianfranco Soldera
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/isole-e-olena')">Isole e Olena
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/italy/tuscany/marchesi-antinori')">Marchesi Antinori
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/podere-poggio-scalette')">Podere Poggio
                        Scalette
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/poderi-boscarelli')">Poderi Boscarelli
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/rocca-di-frassinello')">Rocca di Frassinello
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-dell-ornellaia')">Tenuta dell’Ornellaia
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-di-trinoro')">Tenuta di Trinoro
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-san-guido')">Tenuta San Guido
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Marchesi Antinori</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Se hai mai aperto una bottiglia di Chianti, o in realtà solo un qualsiasi vino rosso italiano, allora è probabile che tu abbia aperto una bottiglia di Marchesi Antinori. Una tenuta massiccia che esprime in modo eloquente
                        l'arte del vino made in Italy, chi dice supertuscan dice Antinori.
                    </div>

                    <div class="howto-title2">Il supereroe del supertuscan</div>
                    <div class="howto-text">
                        Un'incredibile storia di 26 generazioni sottolinea questo mitico vigneto, per così dire ha un
                        storia radicata non è un eufemismo. Da allora la famiglia è nel settore della vinificazione
                        1385, e questi oltre 630 anni li hanno aiutati ad affinare la loro visione vinicola. Oggi lo è
                        Piero Marchesi che gestisce lo spettacolo. Una leggenda a sé stante, dice: “Le antiche radici familiari giocano
                        una parte importante della nostra filosofia ma non hanno mai ostacolato il nostro spirito innovativo”. Situato
                        principalmente nel Chianti Classico (a circa 20 minuti da Firenze), i vigneti di Piero hanno tutto
                        gli orpelli della fantasia toscana: filari e filari di viti ben piantate, in leggera pendenza verso sud-ovest
                        colline di fronte e magnifici cipressi che fiancheggiano un casale rustico piastrellato in terracotta. UN
                        la cantina a flusso di gravità leggermente incongrua ma comunque spettacolare completa questo
                        idillio bucolico.
                    </div>

                    <div class="howto-title2">Magnifico Marchesi</div>
                    <div class="howto-text">
                        Un enorme 1.200 ettari di terroir produce 20 milioni (sì, milioni) di bottiglie all'anno in 150
                        diverse etichette e fasce di prezzo. Il più famoso di questi è il Tiganello (è anche il 26°
                        vino più cercato su wine-searcher.com). Sorprendentemente, il vino di punta dei Marchesi Antinori
                        non è stato prodotto fino al 1970, ben lontano dalla produzione annuale di 20.000-30.000 casse di oggi. IL
                        la miscela standard è 80% Sangiovese, 15% Cabernet Sauvignon e 5% Cabernet Franc, anche se alcuni
                        ultimamente sono state apportate modifiche alla ricetta. Non i vigneti più costosi, (sarebbe
                        la Tenuta Guado al Tasso Matarocchio, circa 350€ nel secondo trimestre 2019), alcune annate hanno mostrato
                        crescita formidabile nel 2017, in particolare il 2006 (37,8%), il 2008 (33,6%) e il 2007 (33,1%) e secondo
                        al Liv-ex, tutti i Tiganello di Antinori hanno registrato un incremento minimo del +27%, superando il resto del
                        Vini rossi italiani a “appena” il 13% anno su anno.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Marchesi Antinori</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Wenn Sie jemals eine Flasche Chianti oder eigentlich nur einen beliebigen italienischen Rotwein geöffnet haben, dann ist die Wahrscheinlichkeit groß, dass Sie eine Flasche Marchesi Antinori geöffnet haben. Ein gewaltiges Anwesen, das beredt zum Ausdruck kommt
                        die Kunst der Weinherstellung „made in Italy“, wer „supertoskanisch“ sagt, sagt „Antinori“.
                    </div>

                    <div class="howto-title2">Der Superheld von Super Tuscan</div>
                    <div class="howto-text">
                        Eine unglaubliche 26-Generationen-Geschichte unterstreicht diesen mythischen Weinberg, sozusagen hat er eine
                        Die tief verwurzelte Geschichte ist keine Untertreibung. Seitdem ist die Familie im Weinbau tätig
                        1385, und diese über 630 Jahre haben ihnen geholfen, ihre Weinbauvision zu verfeinern. heute ist es
                        Piero Marchesi, der die Show leitet. Er ist selbst eine Legende und sagt: „Alte Familienwurzeln spielen eine Rolle.“
                        ein wichtiger Teil unserer Philosophie, aber sie haben unseren Innovationsgeist nie beeinträchtigt.“ Gelegen
                        Pieros Weinberge liegen hauptsächlich im Chianti Classico (etwa 20 Minuten außerhalb von Florenz) und bieten alles
                        die Insignien der toskanischen Fantasie: Reihe um Reihe ordentlich gepflanzter Weinreben, sanft nach Südwesten abfallend
                        Mit Blick auf Hügel und prächtige Zypressen, die ein rustikales Bauernhaus mit Terrakottafliesen flankieren. A
                        Das etwas unpassende, aber dennoch spektakulär groovige Gravity-Flow-Weingut rundet das Ganze ab
                        idyllische Idylle.
                    </div>

                    <div class="howto-title2">Magnifico Marchesi</div>
                    <div class="howto-text">
                        Riesige 1.200 Hektar Terroir produzieren auf 150 Hektar 20 Millionen (ja, Millionen) Flaschen pro Jahr
                        verschiedene Labels und Preisklassen. Der bekannteste davon ist der Tiganello (es ist auch der 26.).
                        (meistgesuchter Wein auf wine-searcher.com). Erstaunlicherweise der Flaggschiffwein von Marchesi Antinori
                        wurde erst 1970 hergestellt, weit entfernt von der heutigen jährlichen Produktion von 20.000 bis 30.000 Kisten. Der
                        Die Standardmischung besteht aus 80 % Sangiovese, 15 % Cabernet Sauvignon und 5 % Cabernet Franc, wenn auch einige
                        In letzter Zeit wurden Änderungen am Rezept vorgenommen. Nicht die teuersten Weinberge (das wäre
                        die Tenuta Guado al Tasso Matarocchio, etwa 350 € im zweiten Quartal 2019), bestimmte Jahrgänge wurden angezeigt
                        Tolles Wachstum im Jahr 2017, insbesondere in den Jahren 2006 (37,8 %), 2008 (33,6 %) und 2007 (33,1 %).
                        Laut Liv-ex verzeichneten alle Tiganellos von Antinori einen minimalen Anstieg von +27 % und übertrafen damit den Rest
                        Italienische Rotweine im Jahresvergleich „nur“ 13 %.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Marchesi Antinori</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Si vous avez déjà ouvert une bouteille de Chianti, ou en fait n'importe quel vin rouge italien, il y a de fortes chances que vous ayez ouvert une bouteille de Marchesi Antinori. Un domaine massif qui exprime avec éloquence
                        l'art de la vinification made in Italy, ceux qui disent super toscan disent Antinori.
                    </div>

                    <div class="howto-title2">Le super-héros du super toscan</div>
                    <div class="howto-text">
                        Une histoire incroyable de 26 générations souligne ce vignoble mythique, pour ainsi dire, il a une
                        l'histoire profonde n'est pas un euphémisme. La famille est dans le domaine viticole depuis
                        1385, et ces 630 années et plus les ont aidés à affiner leur vision viticole. Aujourd'hui c'est
                        Piero Marchesi qui dirige le spectacle. Une légende à part entière, dit-il "Les racines familiales anciennes jouent
                        partie importante de notre philosophie, mais ils n'ont jamais entravé notre esprit d'innovation. Situé
                        principalement dans le Chianti Classico (à environ 20 minutes de Florence), les vignobles de Piero ont tous
                        les signes extérieurs de la fantaisie toscane: des rangées de vignes soigneusement plantées, en pente douce vers le sud-ouest
                        face à des collines et de magnifiques cyprès flanquant une ferme rustique en terre cuite. UN
                        une cave à écoulement par gravité légèrement incongrue mais néanmoins spectaculairement groovy complète ce
                        idylle bucolique.
                    </div>

                    <div class="howto-title2">Magnifico Marchesi</div>
                    <div class="howto-text">
                        Un massif de 1 200 hectares de terroir produit 20 millions (oui, millions) de bouteilles par an sur 150
                        différentes étiquettes et gammes de prix. Le plus célèbre d'entre eux est le Tiganello (c'est aussi le 26
                        vins les plus recherchés sur wine-searcher.com). Étonnamment, le vin phare de Marchesi Antinori
                        n'a été produit qu'en 1970, bien loin de la production annuelle de 20 000 à 30 000 caisses d'aujourd'hui. Le
                        mélange standard est de 80% Sangiovese, 15% Cabernet Sauvignon et 5% Cabernet Franc, bien que certains
                        des ajustements ont été apportés à la recette dernièrement. Pas les vignobles les plus chers, (ce serait
                        la Tenuta Guado al Tasso Matarocchio, environ 350 € au T2 2019), certains millésimes ont montré
                        croissance fulgurante en 2017, notamment les années 2006 (37,8%), 2008 (33,6%) et 2007 (33,1%) et selon
                        à Liv-ex, tous les Tiganello d'Antinori ont affiché une augmentation minimale de + 27%, dépassant le reste de
                        Vins rouges italiens à "seulement" 13% sur un an.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Marchesi Antinori</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        If you have ever opened a bottle of Chianti, or actually just any Italian red wine, then chances are you have opened a bottle of Marchesi Antinori. A massive estate that eloquently expresses
                        the art of made in Italy winemaking, those who say super Tuscan say Antinori.
                    </div>

                    <div class="howto-title2">The superhero of super Tuscan</div>
                    <div class="howto-text">
                        An incredible 26-generation history underscores this mythic vineyard, so to say it has a
                        deep-rooted history is no understatement. The family have been in the winemaking business since
                        1385, and these 630-plus years have helped them hone their vinicultural vision. Today it is
                        Piero Marchesi who runs the show. A legend in his own right, he says “Ancient family roots play
                        an important part in our philosophy but they have never hindered our innovative spirit.” Located
                        mainly in Chianti Classico (about 20-minutes outside of Florence), Piero’s vineyards have all
                        the trappings of Tuscan fantasy: row upon row of neatly planted vines, gently sloping south-west
                        facing hills and magnificent cypress trees flanking a terracotta-tiled rustic farmhouse. A
                        slightly incongruous but nonetheless spectacularly groovy gravity-flow winery completes this
                        bucolic idyll.
                    </div>

                    <div class="howto-title2">Magnifico Marchesi</div>
                    <div class="howto-text">
                        A massive 1,200 hectares of terroir produces 20 million (yes, million) bottles a year across 150
                        different labels and price ranges. The most famous of these is the Tiganello (it’s also the 26th
                        most searched for wine on wine-searcher.com). Astonishingly, Marchesi Antinori's flagship wine
                        wasn’t produced until 1970, a far cry from the 20,000-30,000 case annual production today. The
                        standard blend is 80% Sangiovese, 15% Cabernet Sauvignon and 5% Cabernet Franc, although some
                        tweaks have been made in the recipe of late. Not the vineyards most expensive, (that would be
                        the Tenuta Guado al Tasso Matarocchio, approximately €350 in Q2 2019), certain vintages showed
                        terrific growth in 2017, notably the 2006 (37.8%), 2008 (33.6%) and 2007 (33.1%) and according
                        to Liv-ex, all Antinori’s Tiganellos showed a minimum increase of +27%, outstripping the rest of
                        Italian red wines at “just” 13% year on year.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MarchesiAntinori",
    head: {
        title: 'Marchesi Antinori | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the renowned Marchesi Antinori wine producer, creating high-quality, distinctive wines in the heart of Tuscany for over 600 years. Experience the rich history and craftsmanship of this iconic winery with every sip.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Marchesi Antinori', src: '/wine-guide/italy/tuscany/marchesi-antinori'},
            items: [
                {report: 'Avignonesi', src: '/wine-guide/italy/tuscany/аvignonesi'},
                {
                    report: 'Azienda Agricola Casanova di Neri',
                    src: '/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri'
                },
                {report: 'Azienda Salvioni', src: '/wine-guide/italy/tuscany/azienda-salvioni'},
                {report: 'Castiglione del Bosco', src: '/wine-guide/italy/tuscany/castiglione-del-bosco'},
                {report: 'Conti Constani', src: '/wine-guide/italy/tuscany/conti-constani'},
                {report: 'Fattoria Le Pupille', src: '/wine-guide/italy/tuscany/fattoria-le-pupille'},
                {report: 'Fattoria Poggio di Sotto', src: '/wine-guide/italy/tuscany/fattoria-poggio-di-sotto'},
                {report: 'Fontodi', src: '/wine-guide/italy/tuscany/fontodi'},
                {report: 'Frescobaldi', src: '/wine-guide/italy/tuscany/frescobaldi'},
                {report: 'Gianfranco Soldera', src: '/wine-guide/italy/tuscany/gianfranco-soldera'},
                {report: 'Isole e Olena', src: '/wine-guide/italy/tuscany/isole-e-olena'},
                {report: 'Marchesi Antinori', src: '/wine-guide/italy/tuscany/marchesi-antinori'},
                {report: 'Podere Poggio Scalette', src: '/wine-guide/italy/tuscany/podere-poggio-scalette'},
                {report: 'Poderi Boscarelli', src: '/wine-guide/italy/tuscany/poderi-boscarelli'},
                {report: 'Tenuta dell’Ornellaia', src: '/wine-guide/italy/tuscany/tenuta-dell-ornellaia'},
                {report: 'Tenuta di Trinoro', src: '/wine-guide/italy/tuscany/tenuta-di-trinoro'},
                {report: 'Tenuta San Guido', src: '/wine-guide/italy/tuscany/tenuta-san-guido'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}
.wine-guide-body {
    padding-top: 35px;
}
.wine-guide-left {
    width: 300px;
    display: inline-block;
}
.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}
.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}
.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}
.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
